interface UseCaseContextProps {
  context: string;
  accentColor: string;
}

const UseCaseContext = ({ context, accentColor }: UseCaseContextProps) => {
  return (
    <section className="relative py-20 lg:py-24 bg-[#0A0A0F]">
      {/* Subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/50 to-transparent" />

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-10 animate-fade-up">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-1 w-8 rounded-full" style={{ backgroundColor: accentColor }} />
              <span className="text-sm font-medium uppercase tracking-wider text-white/50">
                Le contexte
              </span>
            </div>
          </div>

          {/* Context card */}
          <div className="relative rounded-2xl p-[1px] bg-gradient-to-b from-white/[0.1] to-transparent animate-fade-up [animation-delay:100ms]">
            <div className="rounded-2xl bg-[#0F0F14]/80 backdrop-blur-xl p-8 lg:p-10">
              <blockquote className="text-xl lg:text-2xl text-white/70 leading-relaxed italic">
                "{context}"
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseContext;
